import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { ReactComponent as LogoFull } from "../../assets/logo_full.svg";
import RegisterApp from "./RegisterApp";
import Product from "./Product";
import ContractorInformation from "./ContractorInformation";
import Address from "./Address";
import { Accordion } from "../../components-shadcn/accordion";
import ButtonSave from "../../../src/components/ButtomSave";
import SigningContract from "./SigningContract";
import Payments from "./Payments";
import Finish from "./Finish";
import axios from "axios";
import { Toaster } from "../../components-shadcn/sonner";
import { toast } from "sonner";
import { useStore } from "../../lib/store";
import { ReactComponent as ReloadIcon } from "../../assets/reload.svg";
import { LoadingSpinner } from "../../components/Loading";
import { AmplitudeLog, handleInstanceAmplitudeCheckout } from "../../lib/amplitude";

// Quitado = tudo que se aplica a este produto está pago/autorizado: entrada
// (se houver) E status_produto sempre E, com dois_cartoes=true, as duas
// faturas de cartão também — os 4 somados, nunca um substituindo o outro
// (AC-068). Exportada à parte para ser testável sem montar a página inteira.
export const verificarPagamentosCheckout = (produtos: any): boolean => {
  const isQuitado = (status: any) => Boolean(status?.autorizado || status?.pago);
  const results: boolean[] = [];
  Object.values(produtos).forEach((produto: any) => {
    let result_entrada = false;
    let result_produto = false;
    if (produto.status_entrada) {
      if (produto.status_entrada.autorizado || produto.status_entrada.pago) {
        result_entrada = true;
      }
    }
    if (produto.status_produto.autorizado || produto.status_produto.pago) {
      result_produto = true;
    }
    const result_dois_cartoes = produto.dois_cartoes
      ? isQuitado(produto.status_primeira_fatura_cc) && isQuitado(produto.status_segunda_fatura_cc)
      : true;
    results.push((produto.status_entrada ? (result_entrada && result_produto) : result_produto) && result_dois_cartoes);
  });
  return results.every((valor) => valor === true);
};

const Checkout: React.FC = () => {

  const params = new URLSearchParams(window.location.search);
  const get_id_pedido = params.get("id_pedido");
  const get_id_negocio = params.get("id_negocio");
  const [loading, setLoading] = useState(true);
  const [allow_finalize, setAllowFinalize] = useState(false);
  const [stage, setStage] = useState(0);
  const { set_stage_seed } = useStore();
  const [request_erros, set_request_erros]: any = useState(false);
  const { sync_checkout, set_sync_checkout } = useStore();
  const { set_credit_card } = useStore();

  const { set_id_pedido } = useStore();
  const { set_id_negocio } = useStore();
  const { set_id_hubspot } = useStore();
  const [openItem, setOpenItem] = useState<string>("");
  const [contato_seed, set_contato_seed] = useState();
  const [empresa_seed, set_empresa_seed] = useState();
  const [negocio_seed, set_negocio_seed] = useState();
  const [endereco_entrega_seed, set_endereco_entrega_seed] = useState();
  const [endereco_cobranca_seed, set_endereco_cobranca_seed] = useState();
  const { produtos, set_produtos } = useStore();

  const [first, setFirst] = useState(true);

  const tags_inicio = [
    "0",
    "1",
    "informacoes_contratante",
    "endereco",
    "assinatura_contrato",
    "pagamento",
  ]

  const finalizeCheckout = async () => {
    AmplitudeLog("Checkout_Finalizado")
    setLoading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/checkout_finalize",
        {
          "id_negocio": get_id_negocio,
          "id_pedido": get_id_pedido
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        setLoading(false);
        set_sync_checkout(true);
      } else {
        setLoading(false);
        toast("Erro ao finalizar checkout: ", {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
      }
    } catch (erro: any) {
      toast("Erro ao finalizar checkout: " + erro.message, {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      setLoading(false);
    }
  };

  const VerifyPayments = (produtos: any) => {
    setAllowFinalize(verificarPagamentosCheckout(produtos));
  }

  const GetDataInvoices = async () => {
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/get_data_checkout",
        {
          id_pedido: get_id_pedido,
          id_negocio: get_id_negocio,
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );
      if (resposta.data.status_code === 200) {
        if (resposta.data.produtos) {
          //Prenchimento dos campos com os dados retornados salvos.
          set_produtos(resposta.data.produtos);
          set_contato_seed(resposta.data.contato);
          set_empresa_seed(resposta.data.empresa);
          set_negocio_seed(resposta.data.negocio);
          set_endereco_entrega_seed(resposta.data.enderecos.entrega);
          set_endereco_cobranca_seed(resposta.data.enderecos.cobranca);
          //Pagamentos
          set_credit_card(resposta.data.cartao);
          VerifyPayments(resposta.data.produtos)
          //Demais configurações
          setLoading(false);
          setStage(resposta.data.stage);
          set_stage_seed(resposta.data.stage);
          setOpenItem(resposta.data.stage.toString());
          set_id_hubspot(get_id_negocio ? get_id_negocio.toString() : "");
          if (first) {
            AmplitudeLog("viu_checkout");
          }
          setFirst(false);
          AmplitudeLog("Checkout_Etapa_Visualizada", { nome_etapa: tags_inicio[resposta.data.stage] })
        } else {
          toast("Nenhum produto encontrado", {
            action: {
              label: "X",
              onClick: () => console.log("Undo"),
            },
            className: "!bg-red-dark !text-white-primary",
          });
          set_request_erros(true);
          setLoading(false);
        }
      } else {
        toast(
          "Erro ao carregar produtos: " +
          resposta.data.status_code +
          " " +
          resposta.data.msg,
          {
            action: {
              label: "X",
              onClick: () => console.log("Undo"),
            },
            className: "!bg-red-dark !text-white-primary",
          }
        );
        set_request_erros(true);
        setLoading(false);
      }
    } catch (erro: any) {
      toast("Erro ao carregar " + erro.message, {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
    }
  };

  const _renderProducts = () => {
    return (
      <div className={`${!isMobile && 'flex flex-col gap-y-[1rem]'}`}>
        {produtos.dinamometro_tracao && (
          <Product
            title={"Dinamômetro de tração"}
            valor={produtos.dinamometro_tracao.valor}
            parcelas={produtos.dinamometro_tracao.quantidade_parcelas}
            unidades={produtos.dinamometro_tracao.quantidade}
            theme="gray"
            imagem="dinamometro_tracao"
          />
        )}
        {produtos.dinamometro_palmar && (
          <Product
            title={"Dinamômetro palmar"}
            valor={produtos.dinamometro_palmar.valor}
            parcelas={produtos.dinamometro_palmar.quantidade_parcelas}
            unidades={produtos.dinamometro_palmar.quantidade}
            theme="gray"
            imagem="dinamometro_palmar"
          />
        )}
        {produtos.assinatura && (
          <Product
            title={"Plano " + produtos.assinatura.plano}
            valor={produtos.assinatura.valor}
            parcelas={produtos.assinatura.quantidade_parcelas}
            theme="gray"
            imagem="assinatura"
          />
        )}
      </div>
    );
  };

  const _renderForms = () => {
    return (
      <>
        <div>
          <LogoFull className="w-[10rem] h-[2.1rem]" />
        </div>
        <div
          className={`flex ${isMobile
            ? "flex-col w-[100%]"
            : "flex-row w-[60%] flex-row-reverse mt-[3rem] gap-[3rem]"
            }`}
        >
          <div className={`${!isMobile && "w-[40%] p-[2rem] bg-[#f1f2f3]"}`}>
            {openItem === "" || !isMobile ? _renderProducts() : <></>}
          </div>
          <div className={`${!isMobile && "w-[60%]"}`}>
            <Accordion
              type="single"
              collapsible
              className="w-full"
              value={openItem}
              onValueChange={(value) => {
                setOpenItem(value);
                Number(value) !== 0 && AmplitudeLog("Checkout_Etapa_Visualizada", { nome_etapa: tags_inicio[Number(value)] });
              }}
            >
              <div className="mt-[1rem]">
                <ContractorInformation
                  openItem={openItem}
                  contato_seed={contato_seed}
                  empresa_seed={empresa_seed}
                  negocio_seed={negocio_seed}
                />
                <Address
                  openItem={openItem}
                  endereco_entrega_seed={endereco_entrega_seed}
                  endereco_cobranca_seed={endereco_cobranca_seed}
                />
                <SigningContract openItem={openItem} />
                <Payments openItem={openItem} />
              </div>
            </Accordion>
            <ButtonSave
              icon="none"
              theme="blue"
              className={`${!allow_finalize && "opacity-25"}`}
              onClick={() => {
                allow_finalize && finalizeCheckout();
              }}
            >
              Finalizar cadastro
            </ButtonSave>
          </div>
        </div>
      </>
    );
  };

  const _renderLoading = () => {
    return (
      <div className="flex h-[100dvh] justify-center items-center">
        {request_erros === true ? (
          <ReloadIcon
            onClick={() => {
              GetDataInvoices();
              set_request_erros(false);
            }}
            className="w-[2rem] h-[2rem]"
          />
        ) : (
          <LoadingSpinner />
        )}
      </div>
    );
  };

  useEffect(() => {
    if (sync_checkout) {
      set_sync_checkout(false);
      get_id_pedido && set_id_pedido(get_id_pedido);
      get_id_negocio && set_id_negocio(get_id_negocio);
      GetDataInvoices();
    }
  }, [sync_checkout]);

  useEffect(() => {
    handleInstanceAmplitudeCheckout();
  }, []);

  return (
    <div
      className={`
        px-[2rem]
        py-[2rem]
        w-[100%]
        rounded-t-[1.5rem]
        flex flex-col items-center
        overflow-y-auto max-h-[100vh]
        bg-white-primary
     `}
    >
      {loading && _renderLoading()}
      {!loading && stage === 1 && <RegisterApp />}
      {!loading && [2, 3, 4, 5].includes(stage) && _renderForms()}
      {!loading && stage === 6 && <Finish />}
      {!loading && stage === 7 && <p>Pedido cancelado!</p>}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 10000,
        }}
      />
    </div>
  );
};

export default Checkout;
